import React, { ReactElement } from "react";
import styles from "./index.module.scss";

interface PropType {
  children: ReactElement[] | ReactElement;
}

export default function HRCardListing({
  children
}: PropType) {
  return <div className={styles.EntityWraps}>{children}</div>;
}
